// Ordered bone-id lists per rig, keyed by rigId. `CORE_RIG_BONES` (NeutralBiped)
// seeds this at core-pack registration; a project's own custom rigs can add
// theirs too, so posing UI and the generic skeleton renderer aren't limited to
// the one built-in biped.
const RIG_BONES = new Map<string, string[]>();

/** Register (or override) the ordered bone ids for a rig. */
export function registerRigBones(rigId: string, boneIds: string[]): void {
  RIG_BONES.set(rigId, boneIds);
}

/** Ordered bone ids for a rig, or null if nothing is registered for it. */
export function getRigBones(rigId: string): string[] | null {
  return RIG_BONES.get(rigId) ?? null;
}

export function listRegisteredRigIds(): string[] {
  return [...RIG_BONES.keys()];
}
